import React from 'react';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { convertUtcToLocalTime } from '../../helper';
import * as _ from 'lodash';

export function s2ab(s) {
  let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  let view = new Uint8Array(buf); //create uint8array as viewer
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
}

function fitToColumn(data) {
  let colInfo = [];
  for (const props in data[0]) {
    const colWidth = Math.ceil(data[0][props].toString().length / 5) * 5;
    colInfo = [...colInfo, { wch: colWidth }];
  }
  return colInfo;
}

const exportToExcel = async (policyList) => {
  const today = moment().format('DD-MM-YYYY');
  const exportData = policyList?.map(policy => {
    return {
      'Ngày trích xuất report': today,
      'Số hợp đồng': policy?.policynum,
      'Ngày phát hành': convertUtcToLocalTime(policy?.policyissuedt, 'DD-MM-YY'),
      'Sản phẩm': policy?.baseproductname,
      'Phí BH đến hạn': policy?.premiumdueamount.toLocaleString("en-US"),
      'Ngày đến hạn đóng phí': convertUtcToLocalTime(policy?.premiumduedate, 'DD-MM-YY'),
      'Họ tên BMBH': policy?.poname,
      'Điện thoại': policy?.pomobile,
      'Email': policy?.poemail,
      'Số CMND/CCCD': policy?.poidentifynum,
      'Khôi phục': _.isEqual(policy?.baseproductcd, 'CCO') ? 'Áp dụng' : 'Không áp dụng'
    }
  });
  let wb = XLSX.utils.book_new();
  wb.Props = {
    Title: 'Báo cáo',
    Subject: 'Báo cáo',
    Author: 'FWD',
    CreatedDate: new Date(),
  };

  let ws = XLSX.utils.json_to_sheet(exportData);
  ws['!cols'] = fitToColumn(exportData);

  wb.SheetNames.push('Data');
  wb.Sheets['Data'] = ws;
  let wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  let fileName = 'ReportPolicy_' + moment().format('YYYYMMDD_hhmmss') + '.xlsx';
  saveAs(new Blob([s2ab(wbOut)], { type: 'application/octet-stream' }), fileName);
}

const Button = ({ policyList }) => {
  return (
    <button className='btn btn-outline-primary' onClick={() => exportToExcel(policyList)} type='button'>
      Download
    </button>
  );
};

const mapStateToProps = (state) => {
  const policyList = state?.policy?.data;
  return { policyList };
};

export default connect(mapStateToProps)(Button);
